import getElementsFromRecords from './getElementsFromRecords';
import InferredElement from './InferredElement';
export { getElementsFromRecords, InferredElement };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/inference/index.js
// module id = 964
// module chunks = 0